import React from 'react';
import { EmptyContent } from 'components';
// import { Link } from 'react-router-dom';
// import { ReactComponent as HashSvg } from 'assets/svg/hash-line.svg';

export const SideThreadComponent = props => {
  // const [comments, setComments] = useState(false);

  return (
    <>
      <EmptyContent recommendations />

      {/* <div className="side__container">
				<div className="side__header">
					<HashSvg width={14} height={18} />
					<span>Dante's Treads</span>
				</div>
				<div className="side__content">
					<div className="thread__card">
						<div className="thread__card__group">
							<div className="thread__card__info">
								<div className="thread__card__body thread__card__body-discover">
									<div className="thread__card__discover__label">
										Tech
									</div>
									<p>
										Lorem ipsum dolor sit amet consecte.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="thread__card">
						<div className="thread__card__group">
							<div className="thread__card__info">
								<div className="thread__card__body thread__card__body-discover">
									<div className="thread__card__discover__label">
										Tech
									</div>
									<p>
										Lorem ipsum dolor sit amet consecte.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="side__container">
				<div className="side__header clearfix">
					<div className="side__header__left float-left">
						<HashSvg width={14} height={18} />
						<span>Discover Treads</span>
					</div>
					<div className="side__header__right float-right">
						<Link to="/discover">View All</Link>
					</div>
				</div>
				<div className="side__content">
					<div className="thread__card">
						<div className="thread__card__group">
							<div className="thread__card__info">
								<div className="thread__card__body thread__card__body-discover">
									<div className="thread__card__discover__label">
										Tech
									</div>
									<p>
										Lorem ipsum dolor sit amet consecte.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="thread__card">
						<div className="thread__card__group">
							<div className="thread__card__info">
								<div className="thread__card__body thread__card__body-discover">
									<div className="thread__card__discover__label">
										Tech
									</div>
									<p>
										Lorem ipsum dolor sit amet consecte.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> 
	*/}
    </>
  );
};
